// extracted by mini-css-extract-plugin
export default {"udyamRegBox":"udhyamReg_udyamRegBox__uSt+z","udhyamReg":"udhyamReg_udhyamReg__i9NAN"};